import * as React from 'react';
import { Flex } from '@latitude/box';
import { Text } from '@latitude/text';
import { ALIGN_ITEMS, FONT_WEIGHT, MARGIN } from '@latitude/core/utils/constants';

var HeroOr = function HeroOr() {
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: ALIGN_ITEMS.CENTER,
    margin: "0 " + MARGIN.M16
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: FONT_WEIGHT.NORMAL
  }, "Or"));
};

export default HeroOr;